import { ReactNode } from "react";

import classNames from "classnames";
import styled from "styled-components";

import { ReactComponent as BadRobot } from "./assets/bad-robot.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";

/** The error page root. */
const ErrorPageRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 800px;
  margin: auto;
`;

/** The error container. */
const ErrorContainer = styled.div`
  width: 50%;
`;

/** the error code. */
const ErrorCode = styled.p`
  font-size: 24px;
`;

/** The error message. */
const ErrorMessage = styled.p`
  font-size: 16px;
`;

/** The error robot. */
const ErrorRobot = styled(BadRobot)`
  height: 362px;
  width: 324px;
`;

/** The error background. */
const ErrorBackground = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 410px;
  z-index: -1;
`;

/** The error background image ground. */
const ErrorGround = styled(Ground)`
  width: 100%;
  height: 100%;
  display: block;
`;

/** The `ErrorPage` component properties. */
export interface ErrorPageProps {
  /** The CSS class name. */
  readonly className?: string;
}

/** A component which displays the content of the general error page. */
export const ErrorPage = (props: ErrorPageProps): ReactNode => {
  const { className } = props;

  return (
    <ErrorPageRoot className={classNames("pageNotFound", className)}>
      <ErrorContainer className="errBlock">
        <ErrorCode className="errCode">Mission error, JUDI is stuck! Refreshing the page should resolve this issue.</ErrorCode>
        <ErrorMessage className="errMsg">
          Refresh didn&apos;t work? Try quitting and reopening your browser, then logging in again. If JUDI still doesn&apos;t load, we may
          be having internal technical issues. Our deepest apologies!
        </ErrorMessage>
      </ErrorContainer>
      <ErrorRobot className="robot" />
      <ErrorBackground className="background">
        <ErrorGround className="ground" />
      </ErrorBackground>
    </ErrorPageRoot>
  );
};
